import { Http } from '@/lib/http';

export class FormDataSettingsService extends Http {
  endPoint = 'onboarder/settings/form-data';
  constructor() {
    super();
  }

  fetchFormData() {
    return this.httpClient().get(this.endPoint);
  }

  updateFormData(id, updates) {
    return this.httpClient().patch(`${this.endPoint}/${id}`, updates);
  }

  createFormData() {
    return this.httpClient().post(this.endPoint);
  }

  delete;
}
